import { RouteConfig } from 'src/routing/types'

const ROUTE: RouteConfig = {
  name: 'cart',
  path: () => '/cart',
}

export default ROUTE
